import PageHeading from "../../../components/desktop/PageHeading";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useAuthStore } from "../../../store/authStore";
import { FaRegEdit } from "react-icons/fa";
import "./Designationmaster.css";
import back from "../../../assets/back.png";
import { useLoaderStore } from "../../../store/loaderStore";
import { api } from "../../../utils/api";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Designationmaster() {
  const { showLoader, hideLoader } = useLoaderStore();
  const [designations, setDesignations] = useState([]);

  const { user, isAuthenticated } = useAuthStore();

  

  const companyId = user?.company_id;

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    designation_name: "",
    status: true,
  });

  const fetchDesignations = async (showToast = false) => {
    try {
      showLoader("master");
      // const response = await fetch(
      //     `${API_BASE_URL}/designation/list/${companyId}`,
      //     {
      //         method: "GET",
      //         headers: getHeaders(),
      //     }
      // );

      const response = await api.get(`/designation/list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to load designations");
      }

      setDesignations(result);

      if (showToast) {
        toast.success("Designations fetched successfully");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load designations");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (companyId && isAuthenticated) {
      fetchDesignations(true);
    }
  }, [companyId, isAuthenticated]);

  const toggleStatus = async (item) => {
    try {
      showLoader("master");
      // const response = await fetch(
      //     `${API_BASE_URL}/designation/update/${item.id}`,
      //     {
      //         method: "PUT",
      //         headers: getHeaders(),
      //         body: JSON.stringify({
      //             designation_name:
      //                 item.designation_name,
      //             isactive:
      //                 item.isactive === 1 ? 0 : 1,
      //         }),
      //     }
      // );

      const response = await api.put(`/designation/update/${item.id}`, {
        designation_name: item.designation_name,
        isactive: item.isactive === 1 ? 0 : 1,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update status");
      }

      await fetchDesignations();

      toast.success(
        `Designation ${
          item.isactive === 1 ? "deactivated" : "activated"
        } successfully`,
      );
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to update status");
    } finally {
      hideLoader();
    }
  };

  const handleEdit = async (item) => {
    try {
      showLoader("master");
      // const response = await fetch(
      //     `${API_BASE_URL}/designation/${item.id}`,
      //     {
      //         method: "GET",
      //         headers: getHeaders(),
      //     }
      // );

      const response = await api.get(`/designation/${item.id}`);

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to load designation");
      }

      setEditId(item.id);

      setForm({
        designation_name: data.designation_name || "",
        status: data.isactive === 1,
      });

      setShowForm(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load designation");
    } finally {
      hideLoader();
    }
  };

  const handleSave = async () => {
    if (!form.designation_name.trim()) {
      alert("Designation Name is required");
      return;
    }

    try {
      showLoader("master");
      let response;

      if (editId) {
        // response = await fetch(
        //     `${API_BASE_URL}/designation/update/${editId}`,
        //     {
        //         method: "PUT",
        //         headers: getHeaders(),
        //         body: JSON.stringify({
        //             designation_name:
        //                 form.designation_name,
        //             isactive:
        //                 form.status ? 1 : 0,
        //         }),
        //     }
        // );

        response = await api.put(`/designation/update/${editId}`, {
          designation_name: form.designation_name,
          isactive: form.status ? 1 : 0,
        });
      } else {
        // response = await fetch(
        //     `${API_BASE_URL}/designation/add`,
        //     {
        //         method: "POST",
        //         headers: getHeaders(),
        //         body: JSON.stringify({
        //             company_id:
        //                 companyId,
        //             designation_name:
        //                 form.designation_name,
        //         }),
        //     }
        // );

        response = await api.post(`/designation/add`, {
          company_id: companyId,
          designation_name: form.designation_name,
        });
      }

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to save designation");
      }

      await fetchDesignations();

      toast.success(
        editId
          ? "Designation updated successfully"
          : "Designation added successfully",
      );

      handleCancel();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to save designation");
    } finally {
      hideLoader();
    }
  };

  const handleCancel = () => {
    setForm({
      designation_name: "",
      status: true,
    });

    setEditId(null);
    setShowForm(false);
  };

  return (
    <div className="designation-master-container">
      <PageHeading>Designation Master</PageHeading>
      {!showForm ? (
        <>
          <div className="designation-master-top">
            <button
              className="add-designation-btn"
              onClick={() => {
                setEditId(null);

                setForm({
                  designation_name: "",
                  status: true,
                });

                setShowForm(true);
              }}
            >
              + Add Designation
            </button>
          </div>

          <div className="designation-table-wrapper">
            <table className="designation-table">
              <thead>
                <tr>
                  <th className="serial-col">Sr.no</th>
                  <th>Designation Name</th>
                  <th className="status-col">Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {designations.map((item, index) => (
                  <tr key={item.id}>
                    <td className="serial-col">{index + 1}</td>

                    <td>{item.designation_name}</td>

                    <td className="status-col">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item.isactive === 1}
                          onChange={() => toggleStatus(item)}
                        />
                        <span className="slider"></span>
                      </label>
                    </td>

                    <td className="action-cell">
                      <FaRegEdit
                        className="edit-icon"
                        onClick={() => handleEdit(item)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="designation-form-container">
          <div className="designation-form-header">
            <img
              src={back}
              alt="Back"
              className="back-btn-img"
              onClick={handleCancel}
            />

            <h3>{editId ? "Edit Designation" : "Add Designation"}</h3>
          </div>

          <div className="designation-form">
            <div className="designation-field-group">
              <label>
                Designation Name <span>*</span>
              </label>

              <input
                type="text"
                value={form.designation_name}
                onChange={(e) =>
                  setForm({
                    ...form,
                    designation_name: e.target.value,
                  })
                }
                placeholder="Enter Designation Name"
              />
            </div>

            {editId && (
              <div className="designation-field-group">
                <label>Status</label>

                <select
                  value={form.status ? "Active" : "Inactive"}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      status: e.target.value === "Active",
                    })
                  }
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            )}
          </div>

          <div className="form-actions">
            <button className="cancel-btn" onClick={handleCancel}>
              Cancel
            </button>

            <button className="save-btn" onClick={handleSave}>
              {editId ? "Update" : "Save"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
